import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const FileUpload = ({ field, value, onChange, error }) => {
  const [fileName, setFileName] = useState('')

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFileName(file.name)
      
      // Check file type
      const allowedTypes = field.allowed_types || ['image/jpeg', 'image/png', 'application/pdf']
      if (!allowedTypes.includes(file.type)) {
        alert(`File type not allowed. Allowed types: ${allowedTypes.join(', ')}`)
        return
      }
      
      // Check file size (default 5MB)
      const maxSize = field.max_size || 5 * 1024 * 1024
      if (file.size > maxSize) {
        alert(`File size too large. Maximum size: ${maxSize / (1024 * 1024)}MB`)
        return
      }
      
      onChange(file)
    }
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-4">
        <Label htmlFor={field.id} className="cursor-pointer">
          <Input
            id={field.id}
            type="file"
            onChange={handleFileChange}
            className="hidden"
            accept={field.allowed_types?.join(',') || '.jpg,.jpeg,.png,.pdf'}
          />
          <Button type="button" variant="outline">
            Choose File
          </Button>
        </Label>
        {fileName && (
          <span className="text-sm text-muted-foreground">{fileName}</span>
        )}
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
      {field.description && (
        <p className="text-sm text-muted-foreground">
          Allowed types: {field.allowed_types?.join(', ') || 'JPG, PNG, PDF'} • 
          Max size: {field.max_size ? `${field.max_size / (1024 * 1024)}MB` : '5MB'}
        </p>
      )}
    </div>
  )
}

export default FileUpload